// Fetch a slide deck by document id from the CMS
// Uses Vite envs: VITE_CMS_BASEURL and VITE_CMS_TOKEN
export async function fetchCmsDeckById(documentId) {
  if (!documentId) {
    throw new Error('Missing deck id');
  }

  // Use only VITE_CMS_BASEURL for base URL
  const baseUrl = import.meta.env.VITE_CMS_BASEURL || '';
  const token = import.meta.env.VITE_CMS_TOKEN;
  if (!token) {
    throw new Error('Missing VITE_CMS_TOKEN');
  }

  // In dev, prefer proxy to avoid CORS: /api/cms -> <CMS_BASE_URL>/api
  const isDev = import.meta.env.DEV;
  const url = isDev
    ? `/api/cms/slide-decks/${documentId}?populate=*`
    : `${String(baseUrl || '').replace(/\/$/, '')}/api/slide-decks/${documentId}?populate=*`;

  const response = await fetch(url, {
    method: 'GET',
    // We use token-based auth; cookies are not required
    credentials: 'omit',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status} ${response.statusText}`);
  }
  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    const responseText = await response.text();
    throw new Error(
      `Expected JSON, but received ${contentType}.\nResponse: ${responseText}`,
    );
  }
  const result = await response.json();
  return result;
}
